import React from 'react';
import { Link } from 'react-router-dom';
import { PageLayout } from '@/components/poof-ui';
import { TeamSection } from '@/components/TeamSection';

const BackArrow: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const TeamPage: React.FC = () => {
  return (
    <PageLayout fullBleed>
      {/* TV grain overlay — matches homepage */}
      <div className="tv-grain" aria-hidden="true" />

      {/* Back button row */}
      <div className="relative z-10 container pt-8 pb-2">
        <Link
          to="/"
          className="inline-flex items-center gap-2 transition-all duration-200"
          style={{
            fontFamily: "'Bangers', cursive",
            fontSize: '1.25rem',
            letterSpacing: '0.12em',
            color: '#0a0a0f',
            background: '#7CFC00',
            border: '3px solid rgba(0,0,0,0.85)',
            boxShadow: '4px 4px 0 rgba(0,0,0,0.8)',
            padding: '6px 18px',
            transform: 'rotate(-1.5deg)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            textDecoration: 'none',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.transform = 'rotate(-1.5deg) scale(1.06) translateY(-2px)';
            el.style.boxShadow = '6px 6px 0 rgba(0,0,0,0.8), 0 0 18px rgba(124,252,0,0.45)';
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.transform = 'rotate(-1.5deg) scale(1) translateY(0)';
            el.style.boxShadow = '4px 4px 0 rgba(0,0,0,0.8)';
          }}
        >
          <BackArrow />
          BACK
        </Link>
      </div>

      <TeamSection />
    </PageLayout>
  );
};

export default TeamPage;
